const STYLES = {
  win: "border-[#00E676]/40 bg-[#00E676]/10 text-[#00E676]",
  loss: "border-[#EF4444]/40 bg-[#EF4444]/10 text-[#EF4444]",
  push: "border-slate-500/40 bg-slate-500/10 text-slate-300",
  void: "border-slate-500/40 bg-slate-500/10 text-slate-400",
  pending: "border-[#F59E0B]/40 bg-[#F59E0B]/10 text-[#F59E0B]",
};

export function StatusBadge({ status, profit }) {
  const label = status === "pending" ? "Pending" : status.toUpperCase();
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`tag border ${STYLES[status] || STYLES.pending}`}
    >
      {status === "pending" && <span className="live-dot h-1.5 w-1.5 rounded-full bg-[#F59E0B]" />}
      {label}
      {status !== "pending" && profit != null && (
        <span className="font-bold">
          {profit > 0 ? `+${profit.toFixed(2)}U` : profit < 0 ? `${profit.toFixed(2)}U` : "0U"}
        </span>
      )}
    </span>
  );
}

export default StatusBadge;
